import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { includes } from 'lodash-es';

import { getAuthenticityToken } from '../../utils/api';
import { init } from '../../utils/i18n';
import Root from './Root';

export const rootElement = document.getElementById('root')!;
export const authenticityToken: string = getAuthenticityToken();

export const gradeOptions: GradeOption[] = JSON.parse(
  rootElement.getAttribute('data-grade-options')!,
);

export const categorizedGradeOptions: CategorizedGradeOptions = JSON.parse(
  rootElement.getAttribute('data-categorized-grade-options')!,
);

export const estimatedAgeFromGradeCode: { [key: string]: number } = JSON.parse(
  rootElement.getAttribute('data-estimated-age-from-grade-code')!,
);

export const thisYear: number = parseInt(
  rootElement.getAttribute('data-this-year')!,
  10,
);

const juniorGradeIds: string[] = JSON.parse(
  rootElement.getAttribute('data-junior-grade-ids')!,
);
export const isJunior = (gradeId: string) => includes(juniorGradeIds, gradeId);

const highSchoolGradeIds: string[] = JSON.parse(
  rootElement.getAttribute('data-high-school-grade-ids')!,
);
export const isHighSchool = (gradeId: string) =>
  includes(highSchoolGradeIds, gradeId);

const highSchoolGraduateGradeId: string[] = JSON.parse(
  rootElement.getAttribute('data-high-school-graduate-grade-id')!,
);
export const isHighSchoolGraduate = (gradeId: string) =>
  includes(highSchoolGraduateGradeId, gradeId);

export const qlearnUrl: string = rootElement.getAttribute('data-qlearn-url')!;

init(JSON.parse(rootElement.getAttribute('data-translations')!));
document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootElement);
  root.render(<Root />);
});

export interface GradeOption {
  code: string;
  value: string;
  label: string;
}

export const gradeCategories = [
  'preschool',
  'elementary_school',
  'junior_high_school',
  'high_school',
  'others',
] as const;

export type GradeCategory = (typeof gradeCategories)[number];
export type CategorizedGradeOptions = Record<GradeCategory, GradeOption[]>;

export const findGradeCategory = (
  gradeOption: GradeOption | undefined,
): GradeCategory | undefined => {
  if (!gradeOption || !categorizedGradeOptions) {
    return undefined;
  }
  return Object.keys(categorizedGradeOptions).find(
    (category: GradeCategory) => {
      return categorizedGradeOptions[category].some(
        (categoryGradeOption: GradeOption) => {
          return gradeOption.code === categoryGradeOption.code;
        },
      );
    },
  ) as GradeCategory | undefined;
};

// Divide label primary and secondary
// e.g. "小学1年生（テスト）" => primary: "小学1年生", secondary: "テスト"
export const getCategoryGradeLabel = (label: string) => {
  const regex = /(（[^（）]+）)|([^（）]+)/g;
  let primary = '';
  let secondary = undefined;
  label.replace(regex, (_, group1, group2) => {
    if (group1) {
      secondary = group1.slice(1, -1);
    } else if (group2.trim()) {
      primary = group2.trim();
    }
    return '';
  });
  return {
    primary: primary as string,
    secondary: secondary as string | undefined,
  };
};
